import {FetchQueryOptions, QueryClient} from '@tanstack/react-query';
import {CACHE_ONLY_CONFIG} from './reactQueryHelper';
import {IS_CLIENT} from '../../common/constant';

interface Params {
  queryClient: QueryClient;
  fetchQueries: FetchQueryOptions[];
  // fetchQueryPromiseAll 사용해서 패칭하고, 컴포넌트에서 useQuery 사용할 때
  // 두 곳 모두 캐싱 config 정보를 주입해야 하는데, 캐싱을 옵셔널로 처리할 수 있도록 파라미터를 추가합니다.
  useCacheConfigInClient?: boolean;
}

export const fetchQueryPromiseAll = async ({
  queryClient,
  fetchQueries,
  useCacheConfigInClient = true,
}: Params) => {
  if (fetchQueries.length > 0) {
    return await Promise.all(
      fetchQueries.map(query => {
        let _query = {...query};
        if (IS_CLIENT && useCacheConfigInClient) {
          _query = {..._query, ...CACHE_ONLY_CONFIG};
        }
        return queryClient.fetchQuery(_query);
      })
    );
  }
  return [];
};
